(function(){
  if (window.__asukaHoverVid) return;
  window.__asukaHoverVid = 1;

  var unlocked = false;
  function unlock(){ unlocked = true; }
  ['pointerdown','click','keydown','touchstart'].forEach(function(ev){
    document.addEventListener(ev, unlock, { passive: true });
  });

  var isTouch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  function vid(c){ return c.querySelector('.card-hover-video'); }

  /* ---------- Desktop: hover to play, sound after first interaction ---------- */
  function enter(c){
    var v = vid(c); if (!v) return;
    v.muted = !unlocked; v.volume = 1; v.style.opacity = '1';
    var p = v.play(); if (p && p.catch) p.catch(function(){ v.muted = true; v.play().catch(function(){}); });
  }
  function leave(c){
    var v = vid(c); if (!v) return;
    v.style.opacity = '0';
    try { v.pause(); v.currentTime = 0; v.muted = true; } catch(e){}
  }
  if (!isTouch){
    document.addEventListener('mouseover', function(e){ var c=e.target.closest('[data-hover-video]'); if(c && !c.contains(e.relatedTarget)) enter(c); });
    document.addEventListener('mouseout',  function(e){ var c=e.target.closest('[data-hover-video]'); if(c && !c.contains(e.relatedTarget)) leave(c); });
    return;
  }

  /* ---------- Mobile/touch: autoplay muted in view + tap-to-unmute speaker ---------- */
  function addSpeaker(c, v){
    if (c.__asukaSpk) return c.__asukaSpk;
    c.style.position = c.style.position || 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Toggle sound');
    b.setAttribute('data-asuka-spk', '1');
    b.textContent = '🔇';
    b.style.cssText = 'position:absolute;bottom:10px;right:10px;z-index:6;background:rgba(0,0,0,.55);color:#fff;border:0;border-radius:50%;width:34px;height:34px;font-size:15px;line-height:34px;text-align:center;padding:0;display:none;cursor:pointer;';
    b.addEventListener('click', function(ev){
      ev.preventDefault(); ev.stopPropagation();
      if (v.muted){
        document.querySelectorAll('.card-hover-video').forEach(function(o){ o.muted = true; });
        document.querySelectorAll('[data-asuka-spk]').forEach(function(o){ o.textContent = '🔇'; });
        v.muted = false; v.volume = 1; v.play().catch(function(){}); b.textContent = '🔊';
      } else { v.muted = true; b.textContent = '🔇'; }
    });
    c.appendChild(b);
    c.__asukaSpk = b;
    return b;
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var c = e.target, v = vid(c); if (!v) return;
      var spk = c.__asukaSpk;
      if (e.isIntersecting && e.intersectionRatio >= 0.6){
        v.style.opacity = '1'; if (v.paused){ v.play().catch(function(){}); }
        if (spk) spk.style.display = 'block';
      } else {
        try { v.pause(); v.style.opacity = '0'; } catch(_){}
        if (spk) spk.style.display = 'none';
      }
    });
  }, { threshold: [0, 0.6, 1] }) : null;

  function bind(){
    document.querySelectorAll('[data-hover-video]').forEach(function(c){
      if (c.__asukaBound) return;
      var v = vid(c); if (!v) return;
      c.__asukaBound = 1;
      v.muted = true; v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      addSpeaker(c, v);
      if (io) io.observe(c);
    });
  }
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
